import React, { useCallback, useState } from 'react';
import styles from './FooterFilter.module.scss';
import RoundedButton from '../../../../../components/RoundedButton/RoundedButton';
import cn from 'classnames';
import { ReactComponent as DeleteIcon } from '../../../../../resource/DeleteIcon.svg';
import { Icon, Popover } from 'antd';
import SaveFilter from '../../../../../components/SaveFilter';
import { FILTER_NAME_VISIBLE_LENGTH } from '../../../../../helpers/filterName';
import { useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';
import { queryKeys } from '../../../queries/queryKeys';
import useSaveDocumentsFilter from '../../../mutation/useSaveDocumentsFilter';

const FooterFilter = ({ onSubmit, onCancel }) => {
  const [savePopoverVisible, setSavePopoverVisible] = useState(false);

  const queryClient = useQueryClient();

  const { isSaveDocumentsFilterLoading, onSaveDocumentsFilter } =
    useSaveDocumentsFilter();

  const existingFilters = queryClient.getQueryData(queryKeys.savedFilters());

  const filterState = useSelector((state) => state.documentFilterNewStore);

  const { filterChanged, ...filterToSave } = filterState;

  const closePopover = useCallback(() => {
    setSavePopoverVisible(false);
  }, []);

  const saveFilter = async ({ filterName }) => {
    if (!filterName || filterName.length === 0 || /^\s*$/.test(filterName))
      return;

    const replace = existingFilters.find((e) => e.name === filterName);

    await onSaveDocumentsFilter({
      Filter: JSON.stringify(filterToSave),
      name: filterName,
      id: replace ? replace.id : null,
      Type: 'DOCS',
    });
    setSavePopoverVisible(false);
  };

  const saveForm = (
    <div className={styles.saveFilterPopover}>
      <SaveFilter
        onSubmit={saveFilter}
        onCancel={closePopover}
        maxNameLength={FILTER_NAME_VISIBLE_LENGTH}
      />
    </div>
  );

  const handleSaveFilterVisibleChange = useCallback((visible) => {
    setSavePopoverVisible(visible);
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.leftBlock}>
        <RoundedButton
          type="primary"
          text="Применить"
          className={cn(styles.btn, styles.applyBtn)}
          onClick={onSubmit}
          disabled={!filterChanged}
        />
        <RoundedButton
          text="Сбросить"
          className={cn(styles.btn, styles.resetBtn)}
          iconLeft={
            <DeleteIcon style={{ cursor: 'pointer', fill: '#0995ED' }} />
          }
          onClick={onCancel}
        />
      </div>
      <Popover
        content={saveForm}
        title="Введите название для фильтра"
        trigger="click"
        placement="top"
        onVisibleChange={handleSaveFilterVisibleChange}
        visible={savePopoverVisible}
      >
        <RoundedButton
          type="link"
          text="Сохранить фильтр"
          className={cn(styles.btn, styles.createBtn)}
          iconLeft={
            <Icon
              type={isSaveDocumentsFilterLoading ? 'loading' : 'plus-circle'}
              style={{ color: '#0995ED', fontSize: 18, marginTop: 2 }}
            />
          }
        />
      </Popover>
    </div>
  );
};

export default FooterFilter;
